<template>
  <div class="receipt">
    <div class="title">領収書発行</div>
    <div class="info">領収書を発行したい場合は、以下の情報に入力し「送信」ボタンをタップしてください。</div>
    <p class='error'>{{error}}</p>
    <label class='input-group'>
      <span>名前</span>
      <input type="text" v-model='custommer_name'/>
      <select v-model="name_appended">
        <option value="様">様</option>
        <option value="御中">御中</option>
        <option value=""></option>
      </select>
    </label>

    <div class="input-group">
      <span>送信先</span>
      <div>
        <label class='radio'>
          <input type="radio" name='contact_type' value='sms'
            v-model='contact_type' 
            @change='contactInput'/>SMS
        </label>
        <i>/</i>
        <label class='radio'>
          <input type="radio" name='contact_type' value='email'
            v-model='contact_type' 
            @change='contactInput'/>Email
        </label>
      </div>
    </div>

    <label class='input-group' v-if='contact_type'>
      <span style='text-transform: uppercase '> 
        {{ contact_type }} 
      </span>
      <input type="text" v-model='contact' 
        :placeholder="contact_type === 'sms' ? '01234567' : 'example@example.com'"
        @change='contactInput'/>
    </label>
    <label class="input-group">
      <span> 但し書き </span>
      <input type="text" v-model='provision'>
    </label>
    <div class="floating-actions settled">
      <button type='button' class="btn" 
        :disabled='!submitable' 
        @click='submit'>
        送信
      </button>
      <button type='button' class='btn btn-danger'
        @click='cancel'>
        発行しない
      </button>
    </div>
  </div>
</template>

<script>
const regexs = {
  phone: /^\+*\d+$/,
  email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
}
export default {
  props: ['order'],
  data: function() {
    return {
      custommer_name: '',
      name_appended: '様',
      contact_type: '',
      provision: '',
      contact: '',

      error: '',
      loading: false,
    }
  },
  computed: {
    submitable: function() {
      return  this.custommer_name !== '' &&
              this.contact_type   !== '' &&
              this.contact        !== '' &&
              this.provision      !== '' &&
              this.error          === ''
    }
  },
  name: "Receipt",
  methods: {
    contactInput: function() {
      if(this.contact === '' && this.contact_type === 'email' ){
        this.contact = this.order.info_steps[4].pay_email;
      }

      if (this.contact === '') {
        this.error = '';
        return false;
      }
      var checker = this.contact_type === 'sms' ? regexs['phone'] : regexs['email'];
      if (checker.test(this.contact)) {
        this.error = '';
      } else {
        this.error = this.contact_type === 'sms' ? '電話番号が正しくありません' : "Emailが正しくありません";
      }
    },
    cancel: function() {
      this.$$.alert({
        message: '領収書を発行せず報告を完了しますか？',
        actionText: 'はい',
        cancelText: 'いいえ',
        action: () => {
          this.$router.push({name: this.order.info_steps[4].review_qr_src ? 'orderReview' : 'orders'});
        },
        cancelAction: () => null,
      })
    },
    submit: function() {
      if (!this.loading) {
        let order_id = this.$route.params.id,
            params = {
              type: this.contact_type === 'sms' ? 0 : 1,
              name: this.custommer_name,
              name_appended: this.name_appended,
              proviso: this.provision,
            };
        if (this.contact_type === 'sms')
          params.sms = this.contact;
        else
          params.email = this.contact;

        this.loading = true;
        this.$api
        .postReceipt(order_id, params)
        .then(()=>{
          this.$router.push({name: this.order.info_steps[4].review_qr_src ? 'orderReview' : 'orders'});
          this.$$.flash();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
        })
      }
    }
  },
  created: function(){
    if (!this.order) this.$router.push({name: 'orderSteps'})
  },
  mounted: function() {
    this.$$.context({
      title: "ID:"+this.$route.params.id,
      previousRouteName: 'orderSteps',
    });
  }
}
</script>

<style lang='scss'>
.receipt {
  padding: 1em 2em;
  max-width: 480px;
  margin: auto;
  .title {
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
  }
  .info {
    margin: 1em;
  }
  .error {
    color: red;
    height: 2em;
    text-align: center;
  }
  .input-group {
    margin: .5em 0 1.5em;
    display: flex;
    align-items: center;
    > span {
      width: 7em;
      display: block;
      margin-bottom: .5em;
    }
    > div {
      width: 100%;
    }
    input {
      margin-bottom: .5em;
      font-size: 16px;
    }
    select {
      font-size: 1.2em;
      padding: .26em;
      margin-bottom: .5em;
      height: auto;
    }
  }
  .btn {
    min-width: 10em;
  }
}
</style>